module.exports = __webpack_public_path__ + "media/images/riders/small/KARL_MARKT-a42643354ea4fdc8ca0f21f0b374b255.png";